import React, { useState } from "react";
import { Segmented } from "antd";
import InteviewScheduleForm from "./InteviewScheduleForm";
import ReportUrls from "./ReportUrls";

const InterviewScheduleMain = () => {
  const [selectedTab, setSelectedTab] = useState("Schedule Interview");

  return (
    <div className=" my-2 flex flex-col items-center justify-center">
      <Segmented
        options={["Schedule Interview", "Reports"]}
        value={selectedTab}
        size="large"
        // block
        // className="w-full"
        onChange={setSelectedTab}
      />
      <div className="w-full min-h-[72vh] m-auto flex">
        {selectedTab === "Schedule Interview" ? (
          <div className="w-full m-auto flex items-center">
            <InteviewScheduleForm />
          </div>
        ) : (
          <div className="w-full m-auto flex items-center">
            <ReportUrls />
          </div>
        )}
      </div>
    </div>
  );
};

export default InterviewScheduleMain;
